var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00127 13.5902C2.61074 13.9807 2.61074 14.6139 3.00127 15.0044C3.39179 15.3949 4.02496 15.3949 4.41548 15.0044L9.0036 10.4163L13.592 15.0047C13.9825 15.3952 14.6157 15.3952 15.0062 15.0047C15.3967 14.6141 15.3967 13.981 15.0062 13.5904L10.4178 9.00205L15.0057 4.41414C15.3962 4.02361 15.3962 3.39045 15.0057 2.99992C14.6152 2.6094 13.982 2.6094 13.5915 2.99992L9.0036 7.58784L4.41597 3.00021C4.02544 2.60968 3.39228 2.60968 3.00175 3.00021C2.61123 3.39073 2.61123 4.0239 3.00175 4.41442L7.58938 9.00205L3.00127 13.5902Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.4885e3e7ea2a868a7dd53b1c2df4318a.svg";
export { ForwardRef as ReactComponent };